import React from 'react';
import { Typography, Link, Alert } from '@one-thd/sui-atomic-components';
import { IErrorReturnService } from '../../models/errors';

interface IFinalizeReturnErrorMessage {
  [key: string]: string;
  SSR_UPS_ERR_1001: string;
  SSR_UPS_ERR_1002: string;
  DEFAULT: string;
}
export const finalizeReturnErrorMessage: IFinalizeReturnErrorMessage = {
  SSR_UPS_ERR_1001:
    "This item(s) can't be returned online. You can return an item at any The Home Depot store, or call Customer Support at 1-800-430-3376 if you have questions. See our Returns Policy for more information.",
  SSR_UPS_ERR_1002:
    "UPS drop-off returns can't exceed 150 lbs. You can reduce the selected return quantities. Or you can return all items in store.",
  DEFAULT:
    "We're sorry. There was a temporary technical error. Please try again shortly or call 1-866-333-3551 for assistance.",
};

interface FinalizeReturnErrorProps {
  error: IErrorReturnService;
}
const FinalizeReturnError = ({ error }: FinalizeReturnErrorProps) => {
  let body;
  switch (error?.code) {
    case 'SSR_UPS_ERR_1001':
      body = (
        <Typography variant="body-base">
          This item(s) can&apos;t be returned online. You can return an item at
          any The Home Depot store, or call Customer Support at{' '}
          <Link href="tel:+1-800-430-3376">1-800-430-3376</Link> if you have
          questions. See our{' '}
          <Link href="https://www.homedepot.com/c/Pro_Return_Policy">
            Returns Policy
          </Link>{' '}
          for more information.
        </Typography>
      );
      break;
    case 'SSR_UPS_ERR_1002':
      body = (
        <Typography variant="body-base">
          UPS drop-off returns can&apos;t exceed 150 lbs. You can reduce the
          selected return quantities. Or you can return all items in store.
        </Typography>
      );
      break;
    default:
      body = (
        <Typography variant="body-base">
          We&apos;re sorry. There was a temporary technical error. Please try
          again shortly or call{' '}
          <Link href="tel:+1-866-333-3551">1-866-333-3551</Link> for assistance.
        </Typography>
      );
  }

  return (
    <div className="sui-mb-4">
      <Alert status="error" size="large">
        {body}
      </Alert>
    </div>
  );
};

export default FinalizeReturnError;
